// Related products (storefront, aldoo.com): the framework's extension
// (aldoo-ra/Store/extensions/related) with the site's own cards. The server
// sends the linked products as small cards; the rows load them again as the
// store lists them (LIST_FIELDS: discounts, ratings, the buy button) and keep
// the order the editor gave.
import React from "react"
import { RelatedProducts } from "aldoo-ra/Store/extensions/related/storefront"
import ProductScrollableList from "../../../Storefront/ui/ProductScrollableList"
import useAsync from "../../../Storefront/hooks/useAsync"
import useSiteLanguage, { useCurrency } from "../../../Storefront/hooks/useSiteLanguage"
import { ListProducts, LIST_FIELDS } from "../../../Storefront/api"

function Row({ id, title, pids }) {
  const language = useSiteLanguage()
  const currency = useCurrency()
  const key = pids.join(",")
  const { result } = useAsync(
    () => ListProducts({ page: 0, pids, items_per_page: pids.length, language, currency, owned_only: false, fields: LIST_FIELDS }),
    [key, language, currency],
    { enabled: pids.length > 0 }
  )
  const listed = result?.list || []
  const products = pids.map((pid) => listed.find((product) => product.pid === pid)).filter(Boolean)
  if (!products.length) return null
  return (
    <div data-testid={`related-row-${id}`}>
      <ProductScrollableList placement="related" title={title} products={products} moreProductsBtn={false} />
    </div>
  )
}

function SiteRelatedProducts({ product }) {
  return <RelatedProducts product={product} renderRow={(row) => <Row {...row} />} />
}

export const StorefrontExtension = {
  id: "related",
  label: "Related products",
  slots: { recommendations: SiteRelatedProducts },
}
